import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);

export const formatNumber = (value, options = {}) => {
  if (value === null || value === undefined || isNaN(value)) return '0';

  const { decimals = 0, prefix = '', suffix = '', locale = 'en-US' } = options;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number(value));
};

export function formatPeriod(startDate, endDate) {
  return `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`;
}

export function formatDate(date, format = 'DD/MM/YYYY HH:mm:ss') {
  try {
    return dayjs.utc(date).tz('Asia/Yangon').format(format);
  } catch (error) {
    return '-';
  }
}

export function columnSorter(dataIndex, type = 'string') {
  switch (type) {
    case 'number':
      return (a, b) => a[dataIndex] - b[dataIndex];
    case 'date':
      return (a, b) => new Date(a[dataIndex]) - new Date(b[dataIndex]);
    case 'string':
    default:
      return (a, b) =>
        a[dataIndex]?.toString()?.localeCompare(b[dataIndex].toString(), undefined, {
          numeric: true,
          sensitivity: 'base',
        });
  }
}
